document.addEventListener('DOMContentLoaded', function() {
  console.log('✅ Timer script chargé');

  let timerDuration = 20 * 60; // 20 minutes
  let timerInterval = null;
  let timerRunning = false;

  function updateDisplay() {
    const timerDisplay = document.getElementById('cart-timer');
    if (!timerDisplay) return;
    const minutes = Math.floor(timerDuration / 60);
    const seconds = timerDuration % 60;
    timerDisplay.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }

  function startTimer() {
    const announcement = document.getElementById('cart-announcement');
    if (!announcement) return;
    if (timerRunning) return;

    console.log('✅ Timer démarré');

    timerRunning = true;
    timerDuration = 20 * 60;
    updateDisplay();
    announcement.style.display = 'block';

    timerInterval = setInterval(() => {
      timerDuration--;
      if (timerDuration <= 0) {
        clearInterval(timerInterval);
        timerInterval = null;
        timerRunning = false;
        const timerDisplay = document.getElementById('cart-timer');
        if (timerDisplay) timerDisplay.textContent = '00:00';
        announcement.style.display = 'none';
        console.log('⛔ Timer terminé, annonce cachée');
      } else {
        updateDisplay();
      }
    }, 1000);
  }

  function resetTimer() {
    if (timerInterval) {
      clearInterval(timerInterval);
      timerInterval = null;
    }
    timerRunning = false;
    const announcement = document.getElementById('cart-announcement');
    const timerDisplay = document.getElementById('cart-timer');
    if (announcement) announcement.style.display = 'none';
    if (timerDisplay) timerDisplay.textContent = '20:00';
    console.log('🔄 Timer reset');
  }

  function handleDrawerChange() {
    const announcement = document.getElementById('cart-announcement');
    const cartItems = document.querySelectorAll('.quick-cart__item');

    if (cartItems.length > 0 && announcement) {
      if (!timerRunning) {
        startTimer();
      }
    } else {
      if (timerRunning) {
        resetTimer();
      }
    }
  }

  function initObserver() {
    const quickCart = document.querySelector('.quick-cart');
    if (!quickCart) {
      console.log('❌ Pas de .quick-cart trouvé');
      return;
    }

    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          handleDrawerChange();
        }
      }
    });

    observer.observe(quickCart, { childList: true, subtree: true });
    console.log('👀 Observation de .quick-cart prête');
  }

  initObserver();
});